import { useContext } from 'react'
import { CashierUserContext } from '@/contexts'

export const useCashierUser = () => useContext(CashierUserContext)
